<template>
  <div class="shop">
    <div class="shop_logo_box">
      <div class="shop_logo_box_image">
        <Skeleton width="100%" height="100%" borderRadius="7px" />
      </div>
      <div class="shop-skeleton-title">
        <Skeleton width="100px" class="mt-2" />
        <div class="shop-skeleton-approve">
          <Skeleton width="15px" circle />
        </div>
        <div class="shop-skeleton-badges">
          <Skeleton width="32px" height="32px" circle />
          <Skeleton width="32px" height="32px" circle class="ml-8" />
        </div>
      </div>
    </div>
    <div class="shop_dividers" />
    <div class="shop_point_box">
      <div class="shop_seller_point">
        <Skeleton width="110px" />
        <Skeleton width="15px" circle />
      </div>
      <Skeleton width="260px" height="7px" class="mt-10" />
      <Skeleton width="15px" height="7px" class="mt-10 ml-10" />
    </div>
  </div>
</template>

<script>
import Skeleton from '@/components/Skeleton/Skeleton';

export default {
  name: 'ShopProfileSkeleton',
  components: {
    Skeleton,
  },
};
</script>

<style lang="scss">
.shop-skeleton {
  &-title {
    display: flex;
    margin-top: 2px;
  }

  &-approve {
    margin-left: 10px;
  }

  &-badges {
    margin-top: 30px;
    position: absolute;
    display: flex;
  }
}
</style>
